import { cva, type VariantProps } from "class-variance-authority";
import { ReactNode } from "react";

type HelperVariant = NonNullable<
  VariantProps<typeof helperVariants>["variant"]
>;

const helperVariants = cva("t-text-body-sm-lite t-italic t-mt-1 t-mb-0", {
  variants: {
    variant: {
      default: "t-text-neutral",
      loading: "t-text-neutral",
      error: "t-text-red-50",
      success: "t-text-green-55",
      warning: "t-text-orange-50",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

type HelperProps = {
  children: ReactNode;
  variant?: HelperVariant;
};

export const HelperText = ({ children, variant = "default" }: HelperProps) => (
  <p className={helperVariants({ variant })}>{children}</p>
);
